
import "./dashboard_top_bar.css";
import { Link,useNavigate } from "react-router-dom";


const DashboardTopBar = ({isTopNav, setIsTopNav,initials, profileModal, setProfileModal}) =>{
      const pageRoute = [
        {
        name: "API",
        id: 1
        },
        /*{
            name: "Guides",
            id: 2
        },
        {
            name: "Support",
            id: 3
        },*/


    ]
    const scrollTo = (id) => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    };
    
        const navigate = useNavigate();

        const navChange = (index) => {
            let currentState = [true,false,false]

            //Route to different page
            switch(index){
                case 0:
                    currentState = [true,false,false]
                    break;
                case 1:
                    currentState = [false,true,false]
                    break;
                case 2:
                    currentState = [false,false,true]
                    break
                default:
                    currentState = [true,false,false]

            }
            setIsTopNav(currentState);
        }   


 


    return(
        <div className="api-nav-whole">
            <nav className="api-nav-section-home">
                {/*logo*/}
                    <div className="api-nav-section-home-logo-container">
                        <p className="api-nav-section-home-title-left">Stock</p>
                        <div className="api-nav-section-home-title-logo">
                        <svg width="35" height="35">
                            <circle cx="10" cy="30" r="3.5" fill="none" strokeWidth="1" stroke="#FFFFFF" />
                            <circle cx="20" cy="30" r="3.5" fill="none" strokeWidth="1" stroke="#FFFFFF" />
                            <circle cx="20" cy="20" r="3.5" fill="none" strokeWidth="1" stroke="#FFFFFF" />
                            <circle cx="30" cy="30" r="3.5" fill="none" strokeWidth="1" stroke="#FFFFFF" />
                            <circle cx="30" cy="20" r="3.5" fill="none" strokeWidth="1" stroke="#FFFFFF" />
                            <circle cx="30" cy="10" r="3.5" fill="none" strokeWidth="1" stroke="#FFFFFF" />
                        </svg>

                        </div>
                        <p className="api-nav-section-home-title-right">Archives</p>
                    </div>
                    <div className="api-nav-section-home-links-container">
                        {
                            pageRoute.map((item,index)=>(
                                <button onClick={() => navChange(index)}  key={item.key} className={isTopNav[index]?"api-nav-section-home-links-container-button-active":"api-nav-section-home-links-container-button"}>{item.name}</button>
                            ))
                        }
                            {/*<button className={"api-nav-section-home-links-container-button"}>API</button>
                            <button className="api-nav-section-home-links-container-button">Guides</button>
                            <button className="api-nav-section-home-links-container-button">Support</button>*/}
                    </div>
                    <div className="api-nav-section-main-profile-container">
                        <div className="api-section-top-api-login-outer">
                            <div className="api-section-top-api-login-inner">
                            <button className="api-top-button" onClick={() => setProfileModal(!profileModal)}>{initials}</button>
                            </div>
                        </div>
                    </div>
            </nav>
        </div>
    )
}

export default DashboardTopBar;